import instance from './instance'

export const logIn = (payload: any) => instance.post('login', payload)
export const googleLogin = (payload: any) => instance.post('googleLogin', payload)

export const currentUser = () => instance.get('currentUser')
